var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adminMobileTransfer"},[_c('div',{staticClass:"sucssInfo"},[_c('span',{staticClass:"icon-al-exclamation-circle"}),_c('p',[_vm._v("为了让您有更好的使用体验，我们建议您在电脑端使用")]),_c('div',{staticClass:"btn",on:{"click":_vm.copyLink}},[_vm._v("复制链接")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }